export const getErrorMessage = (error: unknown) => {
    if(error instanceof Error) return error.message || "Something went wrong."
    return "Something went wrong."
}